import { getDomElements } from '../utils/dom.js';

export function render404Page() {
    const domRefs = getDomElements();

    let html = `
        <h1>Page Not Found</h1>
    `;

    html += `
        <section class="error-section">
            <p>We couldn't find the page you were looking for.</p>
        </section>
    `;

    domRefs.pageContent.innerHTML = html;
    document.title = "Page Not Found";
}